import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MaterialPriceApi } from './material-price';

@Injectable({ providedIn: 'root' })
export class MaterialPricesService {
    constructor(
        private http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    loadMaterialPrices(materialId: number): Observable<MaterialPriceApi> {
        return this.http.get<MaterialPriceApi>(
            this.apiBaseUrl + 'artikel_verkaufspreis/read_vk.php?artikel_id=' + materialId,
        );
    }

    saveMaterialPrices(materialPrices: any): Observable<void> {
        return this.http.post<void>(this.apiBaseUrl + 'artikel_verkaufspreis/update.php', materialPrices);
    }
}
